import { authenticatedApi } from "../api";
import { MICROSERVICE_CONFIG } from "../../config/configs";

export const get_user_by_id_api = async (id) => {
	if (id) {
		return new Promise((resolve, reject) => {
			authenticatedApi
				.get(`${MICROSERVICE_CONFIG.USER}/users/${id}`)
				.then((response) => {
					let { data } = response;
					resolve(data);
				})
				.catch((error) => {
					reject(error);
				});
		});
	}
};

export const change_password_api = async (body) => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.AUTH}/change-password`,
		body
	);
	return response.data;
};

export const updatefullname = async (body) => {
	const formDataObj = {};
	body.forEach((value, key) => (formDataObj[key] = value));

	const { first_name, last_name, id, profile_image } = formDataObj;

	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.USER}/profile/${id}`,
		{
			first_name,
			last_name,
			profile_image,
		},
		{ headers: { "Content-Type": "multipart/form-data" } }
	);
	return response.data;
};

export const updatePhoneNumber = async (param) => {
	const response = await authenticatedApi.patch(
		`${MICROSERVICE_CONFIG.AUTH}/admin/profile/${param.id}?role=admin`,
		{ mobile: param.mobile }
	);
	return response.data;
};

export const getCountryCodes = async () => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.RESTAURANT}/location/countries`
	);
	return response.data;
};

export const logout = async () => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.AUTH}/logout`
	);
	return response.data;
};
